import React, { useMemo } from "react";
import { useSelector } from "react-redux";

/**
 * Use Check  groupName  Present
 */
export default (groupId: number) => {
  const { auth } = useSelector((state) => state);
  return useMemo(() => {
    if (auth && auth.account && auth.account.groups.length) {
      return auth.account.groups.some(({ id }) => id === groupId);
    }
    return false;
  }, [auth]);
};